export const formatPhoneNumber = (phone: string) => {
  // if phone contain + sign, remove it
  if (phone.includes('+')) {
    phone = phone.replace('+', '');
  }
  const phoneNumber = '+' + phone;

  return phoneNumber;
};
